import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h.5m3 0h1.5m3 0h6","key":"svg-0"}],["path",{"d":"M13 18l6 -6","key":"svg-1"}],["path",{"d":"M13 6l6 6","key":"svg-2"}]]

const IconArrowRightDashed = createReactComponent('outline', 'arrow-right-dashed', 'ArrowRightDashed', __iconNode);

export default IconArrowRightDashed;